/** Lighter → darker per hue, then black / grey scale (+ white for tints). */
const REDS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#f44336', '#c62828', '#b71c1c'];
const GREENS = ['#e8f5e9', '#c8e6c9', '#a5d6a7', '#66bb6a', '#43a047', '#2e7d32', '#1b5e20'];
const BLUES = ['#e3f2fd', '#bbdefb', '#90caf9', '#42a5f5', '#1e88e5', '#1565c0', '#0d47a1'];
const YELLOWS = ['#fffde7', '#fff9c4', '#fff176', '#ffee58', '#fdd835', '#f9a825', '#ff8f00'];
const ORANGES = ['#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#fb8c00', '#e65100', '#bf360c'];
const PINKS = ['#fce4ec', '#f8bbd9', '#f48fb1', '#ec407a', '#d81b60', '#ad1457', '#880e4f'];
const BLACK_GREYS = ['#000000', '#212121', '#424242', '#616161', '#757575', '#9e9e9e', '#bdbdbd', '#e0e0e0', '#eeeeee', '#f5f5f5', '#ffffff'];

/** Full palette for text and background swatch grids */
export const EDITOR_COLOR_PALETTE = [
    ...REDS,
    ...GREENS,
    ...BLUES,
    ...YELLOWS,
    ...ORANGES,
    ...PINKS,
    ...BLACK_GREYS,
];

export const EDITOR_COLOR_PALETTE_SET = new Set(EDITOR_COLOR_PALETTE.map((h) => h.toLowerCase()));

export const RECENT_TEXT_COLORS_LS_KEY = 'VuePortal_formHtmlEditor_recentTextColors_v1';
export const RECENT_BG_COLORS_LS_KEY = 'VuePortal_formHtmlEditor_recentBgColors_v1';
export const RECENT_COLORS_MAX = 10;

/** @returns {string[]} */
export function loadStoredColorList(key) {
    if (typeof localStorage === 'undefined')
        return [];
    try {
        const raw = localStorage.getItem(key);
        if (!raw)
            return [];
        const a = JSON.parse(raw);
        if (!Array.isArray(a))
            return [];
        return a
            .map((h) => (typeof h === 'string' ? normalizeHex(h) : ''))
            .filter(Boolean);
    }
    catch {
        return [];
    }
}

export function saveStoredColorList(key, list) {
    if (typeof localStorage === 'undefined')
        return;
    try {
        localStorage.setItem(key, JSON.stringify(list.slice(0, RECENT_COLORS_MAX)));
    }
    catch {
        /* ignore quota */
    }
}

/**
 * @param {string} value
 * @returns {string} '' or #rrggbb lowercase
 */
export function normalizeHex(value) {
    if (!value || typeof value !== 'string')
        return '';
    let h = value.trim();
    if (!h.startsWith('#'))
        return '';
    h = h.slice(1);
    if (h.length === 3)
        h = h.split('').map((c) => c + c).join('');
    if (h.length !== 6 || !/^[0-9a-fA-F]+$/.test(h))
        return '';
    return `#${h.toLowerCase()}`;
}

/**
 * Remember a user-chosen color (not already in the base palette).
 * @param {string} hex
 * @param {string[]} current
 * @param {string} storageKey
 * @returns {string[]} updated list
 */
export function rememberCustomColor(hex, current, storageKey) {
    const h = normalizeHex(hex);
    if (!h)
        return current;
    if (EDITOR_COLOR_PALETTE_SET.has(h))
        return current;
    const next = [h, ...current.filter((x) => x !== h)].slice(0, RECENT_COLORS_MAX);
    saveStoredColorList(storageKey, next);
    return next;
}
